import $ from 'jquery';

const rootSelector = '[data-micro-poll]';
const formSelector = '[data-micro-poll-form]';
const bodySelector = '[data-micro-poll-body]';
const errorSelector = '[data-micro-poll-error]';

const escapeHtml = (value) => $('<div>').text(value || '').html();

const getAjaxData = () => window.WL_MICRO_POLL_DATA || null;

const getAnswerText = (answers, answerId) => {
  const answer = answers.find((item) => item.id === answerId);

  return answer ? answer.text : '';
};

const renderResults = (data) => {
  const answers = data.answers || [];
  const selectedAnswer = data.selectedAnswer || '';
  const total = parseInt(data.total, 10) || 0;
  const voteLabel = total === 1 ? 'vote' : 'votes';

  const results = answers
    .map((answer) => {
      const percent = parseInt(answer.percent, 10) || 0;
      const isSelected = answer.id === selectedAnswer;

      return `
        <div class="micro-poll__result">
          <div class="micro-poll__result-header">
            <span class="micro-poll__result-label">
              ${escapeHtml(answer.text)}
              ${isSelected ? '<span class="micro-poll__pick">(your pick)</span>' : ''}
            </span>
            <span class="micro-poll__result-percent">${percent}%</span>
          </div>
          <div class="micro-poll__result-track">
            <span class="micro-poll__result-bar" style="width: ${percent}%;"></span>
          </div>
        </div>
      `;
    })
    .join('');

  return `
    <div class="micro-poll__thanks">
      <span class="micro-poll__thanks-icon" aria-hidden="true"></span>
      <span>Thanks for voting</span>
    </div>
    <div class="micro-poll__results">
      ${results}
    </div>
    <p class="micro-poll__total">${total.toLocaleString()} ${voteLabel} so far</p>
  `;
};

const pushDataLayerEvent = ($root, data) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'micro_poll_submit',
    pagePath: window.location.pathname,
    postType: $root.data('postType') || '',
    pollId: data.pollId || $root.data('pollId') || '',
    pollQuestion: data.question || $root.data('question') || '',
    pollAnswer: getAnswerText(data.answers || [], data.selectedAnswer || '')
  });
};

$(document).on('change', `${rootSelector} .micro-poll__input`, (event) => {
  const $input = $(event.currentTarget);
  const $root = $input.closest(rootSelector);

  $root.find('.micro-poll__answer').removeClass('is-selected');
  $input.closest('.micro-poll__answer').addClass('is-selected');
});

$(document).on('submit', `${rootSelector} ${formSelector}`, (event) => {
  event.preventDefault();

  const ajaxData = getAjaxData();
  const $form = $(event.currentTarget);
  const $root = $form.closest(rootSelector);
  const $body = $root.find(bodySelector);
  const $error = $form.find(errorSelector);
  const $selected = $form.find('.micro-poll__input:checked');

  if (!$selected.length || !ajaxData) {
    return;
  }

  $error.attr('hidden', true);
  $form.addClass('is-loading').attr('aria-busy', 'true');
  $form.find('.micro-poll__submit').prop('disabled', true);

  $.ajax({
    method: 'POST',
    url: ajaxData.ajaxUrl,
    dataType: 'json',
    data: {
      action: 'micro_poll_vote',
      nonce: ajaxData.nonce,
      postId: $root.data('postId'),
      pollId: $root.data('pollId'),
      answerId: $selected.val()
    }
  })
    .done((response) => {
      if (!response || !response.success || !response.data) {
        throw new Error('Invalid response');
      }

      $root.addClass('is-complete');
      $body.html(renderResults(response.data));
      pushDataLayerEvent($root, response.data);
    })
    .fail(() => {
      $error.removeAttr('hidden');
      $form.find('.micro-poll__submit').prop('disabled', false);
    })
    .always(() => {
      $form.removeClass('is-loading').removeAttr('aria-busy');
    });
});
